document.addEventListener("DOMContentLoaded", function() {
  const header = document.querySelector('.template-index .header-section .header'); 
  const targetDiv = document.querySelector('.homeHero'); 

  if (header && targetDiv) {
    // Listen for the user scrolling
    window.addEventListener('scroll', function() {
      
      // Get the total height of the homeHero in pixels
      const heroHeight = targetDiv.offsetHeight;
      
      // Calculate 50% of the hero's height
      const triggerPoint = heroHeight * 0.9; // Change 0.5 to 0.25 for 25%, etc.

      // If we have scrolled past that 50% point
      if (window.scrollY > triggerPoint) {
        header.classList.add('scrolled');
      } else {
        // If we scroll back up to the top
        header.classList.remove('scrolled');
      }
      
    });
  }
});